var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdyenIdkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-37d303a0": "",
    width: 299,
    height: 260,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 182 158",
    className: "icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47.251 81.388-1.553 8.225-12.98-28.069-7.516 1.63s3.566 46.666 25.155 45.382c8.704-.518 16.393-21.704 16.393-21.704L47.25 81.388Z",
    fill: "#7F4C40",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m64.64 86.373-17.39-4.985-.095.498 17.6 7.823-.115-3.336Z",
    fill: "#00112C",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m45.698 89.613 2.166 3.049",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.977 55.217-8.704-3.125-.633-7.075a1.402 1.402 0 0 1 1.246-1.495c.71-.058 1.342.403 1.477 1.093l1.17 5.732L22.48 54.49",
    fill: "#7F4C40"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m16.977 55.217-8.704-3.125-.633-7.075a1.402 1.402 0 0 1 1.246-1.495c.71-.058 1.342.403 1.477 1.093l1.17 5.732L22.48 54.49",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.345 56.023 6.7 53.013l-2.493-6.155c-.287-.71.058-1.495.748-1.802.652-.269 1.4 0 1.745.613l2.818 5.139 8.858 2.799",
    fill: "#7F4C40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.345 56.023 6.7 53.013l-2.493-6.155c-.287-.71.058-1.495.748-1.802.652-.269 1.4 0 1.745.613l2.818 5.139 8.858 2.799",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m21.981 56.866-6.384-6.787a1.41 1.41 0 0 1-.211-1.937 1.416 1.416 0 0 1 1.917-.306c1.726 1.17 5.369 4.352 9.299 6.154 2.723 1.246 4.467 5.062 5.023 6.308",
    fill: "#7F4C40"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m21.981 56.866-6.384-6.787a1.41 1.41 0 0 1-.211-1.937 1.416 1.416 0 0 1 1.917-.306c1.726 1.17 5.369 4.352 9.299 6.154 2.723 1.246 4.467 5.062 5.023 6.308",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.62 63.5a7.577 7.577 0 0 0-4.468-6.94c-4.927-2.225-8.149-2.474-9.49-2.704-1.4-.23-13.153-2.953-16.95-3.604-.785-.135-1.475.095-1.667.862-.192.767.249 1.573.997 1.822 4.467 1.476 22.144 8.647 23.18 8.896 0 0 .057 2.416.306 4.352",
    fill: "#7F4C40"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.62 63.5a7.577 7.577 0 0 0-4.468-6.94c-4.927-2.225-8.149-2.474-9.49-2.704-1.4-.23-13.153-2.953-16.95-3.604-.785-.135-1.475.095-1.667.862-.192.767.249 1.573.997 1.822 4.467 1.476 22.144 8.647 23.18 8.896 0 0 .057 2.416.306 4.352",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m134.755 81.388 1.553 8.225 12.98-28.069 7.516 1.63s-3.567 46.666-25.155 45.382c-8.704-.518-16.393-21.704-16.393-21.704l19.499-5.464Z",
    fill: "#7F4C40",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.585 13.152c.077-1.725.326-4.429 1.918-6.173 1.648-1.783 6.039-3.068 7.17-1.534.729-2.07 2.761-3.49 4.89-4.045 2.127-.556 4.37-.422 6.575-.25 2.186.173 4.429.384 6.577-.076a4.687 4.687 0 0 1-.825 2.109c.364-.154.71-.288 1.074-.441.498 2.665.019 5.406-.345 8.09a95.86 95.86 0 0 0-.901 12.846c-.02 3.336-.307 7.516-1.937 9.625-1.63 2.109-18.847.767-20.61-.364-1.745-1.132-3.106-8.245-3.222-9.51a69.005 69.005 0 0 1-.287-3.969c-.134-2.665-.21-3.662-.077-6.308Z",
    fill: "#00112C",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m87.168 86.392 30.178-.02 19.192-5.598c-1.342-7.726-11.983-26.477-20.285-28.452-7.132-1.706-12.098-.153-16.718 2.052-2.397 1.15-5.023-.556-7.708-.576",
    fill: "#F3F6F9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m87.168 86.392 30.178-.02 19.192-5.598c-1.342-7.726-11.983-26.477-20.285-28.452-7.132-1.706-12.098-.153-16.718 2.052-2.397 1.15-5.023-.556-7.708-.576",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m94.646 86.392-30.178-.02-19.192-5.598C46.618 73.048 57.47 56.54 65.312 53.09c6.71-2.972 12.347-.92 16.967 1.285 2.397 1.15 5.024-.556 7.708-.576",
    fill: "#F3F6F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m94.646 86.392-30.178-.02-19.192-5.598C46.618 73.048 57.47 56.54 65.312 53.09c6.71-2.972 12.347-.92 16.967 1.285 2.397 1.15 5.024-.556 7.708-.576",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m97.905 40.167-14.494.287-1.19 14.284 5.312 1.476a16.65 16.65 0 0 0 7.343-.153l4.966-1.649-1.937-14.245Z",
    fill: "#7F4C40",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M78.809 28.299s-.94-5.426-4.007-3.068c-3.068 2.358 1.189 9.011 5.253 9.452",
    fill: "#7F4C40"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.809 28.299s-.94-5.426-4.007-3.068c-3.068 2.358 1.189 9.011 5.253 9.452",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M100.992 28.51s.307-5.503 3.624-3.509c3.317 1.994-.326 8.839-4.295 9.74",
    fill: "#7F4C40"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M100.992 28.51s.307-5.503 3.624-3.509c3.317 1.994-.326 8.839-4.295 9.74",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m90.025 15.856-10.737 1.687s-.421 15.645-.421 17.888c0 2.243 5.464 9.011 8.32 9.586.5.096 5.254.135 5.676 0 2.742-.939 8.321-7.343 8.321-9.586 0-2.243-.345-17.888-.345-17.888l-10.814-1.687Z",
    fill: "#7F4C40",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.356 28.088c0-.69-.019-1.4-.038-2.09-1.246 2.147-2.454 4.41-3.988 6.365-.192.25-.403.499-.71.595-.345.115-.709 0-1.016-.192-.306-.192-.556-.441-.843-.652-.844-.633-1.937-.824-2.991-.92-1.457-.134-2.972-.115-4.352.383-1.15.422-2.167 1.17-3.183 1.88-.153.114-.307.21-.499.268-.287.057-.575-.058-.824-.211-1.4-.844-2.032-2.512-2.8-3.892-.383-.69-.766-1.4-1.15-2.11-.115-.21-.479-.67-.479-.92 0 0-.019 2.934 0 4.985v8.609c0 6.288 12.194 12.155 12.194 12.155s11.063-5.867 11.063-12.155c0-6.289-.384-12.098-.384-12.098ZM117.365 86.373l17.39-4.985.096.498-17.62 7.823.134-3.336Z",
    fill: "#00112C",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m118.075 78.608-1.841 59.742-49.235.134-2.684-59.876",
    fill: "#F3F6F9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m118.075 78.608-1.841 59.742-49.235.134-2.684-59.876M136.308 89.613l-2.167 3.049",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m66.999 138.484-2.684 18.693h53.76l-1.841-18.827-49.235.134Z",
    fill: "#00112C",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m165.009 55.217 8.705-3.125.632-7.075a1.4 1.4 0 0 0-1.246-1.495c-.709-.058-1.342.403-1.476 1.093l-1.17 5.732-10.947 4.142",
    fill: "#7F4C40"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m165.009 55.217 8.705-3.125.632-7.075a1.4 1.4 0 0 0-1.246-1.495c-.709-.058-1.342.403-1.476 1.093l-1.17 5.732-10.947 4.142",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m165.642 56.023 9.644-3.01 2.492-6.155c.288-.71-.057-1.495-.747-1.802-.652-.269-1.4 0-1.745.613l-2.818 5.139-8.858 2.799",
    fill: "#7F4C40"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m165.642 56.023 9.644-3.01 2.492-6.155c.288-.71-.057-1.495-.747-1.802-.652-.269-1.4 0-1.745.613l-2.818 5.139-8.858 2.799",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m160.024 56.866 6.385-6.787a1.41 1.41 0 0 0-1.706-2.243c-1.726 1.17-5.369 4.352-9.299 6.154-2.723 1.246-4.467 5.062-5.023 6.308",
    fill: "#7F4C40"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m160.024 56.866 6.385-6.787a1.41 1.41 0 0 0-1.706-2.243c-1.726 1.17-5.369 4.352-9.299 6.154-2.723 1.246-4.467 5.062-5.023 6.308",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M148.387 63.5a7.578 7.578 0 0 1 4.467-6.94c4.928-2.225 8.149-2.474 9.491-2.704 1.399-.23 13.152-2.953 16.948-3.604.787-.135 1.477.076 1.669.862a1.542 1.542 0 0 1-.997 1.822c-4.468 1.476-22.145 8.647-23.18 8.896 0 0-.058 2.416-.307 4.352",
    fill: "#7F4C40"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.387 63.5a7.578 7.578 0 0 1 4.467-6.94c4.928-2.225 8.149-2.474 9.491-2.704 1.399-.23 13.152-2.953 16.948-3.604.787-.135 1.477.076 1.669.862a1.542 1.542 0 0 1-.997 1.822c-4.468 1.476-22.145 8.647-23.18 8.896 0 0-.058 2.416-.307 4.352",
    stroke: "#00112C",
    strokeWidth: 0.387,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdyenIdkIcon);
export default __webpack_public_path__ + "static/media/adyen-idk-icon.60f0132b.svg";
export { ForwardRef as ReactComponent };